import React from "react";
import { Box, Container, Typography, Grid, Divider, Chip } from "@mui/material";
import {
  Church,
  LocationOn,
  Phone,
  Email,
  AccessTime,
  Instagram,
  YouTube,
} from "@mui/icons-material";
import theme from "../Theme";

export const Sobre = () => {
  const valores = [
    "Vida de fe\u0301",
    "Unidade e amor",
    "Integridade",
    "Alegria e paz",
    "Firmeza doutrina\u0301ria",
    "Fervor de espi\u0301rito",
    "Corac\u0327a\u0303o para servir",
    "Edificar pessoas",
    "Excele\u0302ncia",
    "Vida abundante",
  ];

  const cultos = [
    {
      dia: "Terc\u0327a-feira",
      horario: "20h",
      nome: "Culto de Orac\u0327a\u0303o",
    },
    { dia: "Quarta-feira", horario: "15h", nome: "Culto das Mulheres" },
    { dia: "Quinta-feira", horario: "20h", nome: "Quinta Especial" },
    { dia: "Sa\u0301bado", horario: "19:30h", nome: "Culto de Jovens" },
    { dia: "Domingo", horario: "10h", nome: "Escola Dominical" },
    { dia: "Domingo", horario: "18h", nome: "Culto de Celebrac\u0327a\u0303o" },
  ];

  return (
    <Box sx={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}>
      {/* HERO */}
      <Box
        sx={{
          background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 50%, ${theme.palette.primary.dark} 100%)`,
          color: "white",
          pt: { xs: "110px", md: "130px" },
          pb: { xs: 6, md: 8 },
          textAlign: "center",
          position: "relative",
          overflow: "hidden",
          "&::after": {
            content: '""',
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: "80px",
            background: "linear-gradient(to top, #f8f9fa, transparent)",
          },
        }}
      >
        <Container maxWidth="md" sx={{ position: "relative", zIndex: 1 }}>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 800,
              mb: 1,
              fontSize: { xs: "1.8rem", md: "2.8rem" },
              letterSpacing: "-0.02em",
            }}
          >
            Igreja Evang{"e\u0301"}lica Verbo da Vida
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 400,
              opacity: 0.85,
              mb: 2,
              fontSize: { xs: "0.95rem", md: "1.15rem" },
            }}
          >
            Campina Grande {"\u2014"} Zona Sul
          </Typography>
          <Divider
            sx={{
              width: 60,
              height: 3,
              backgroundColor: "rgba(255,255,255,0.5)",
              mx: "auto",
              borderRadius: 2,
              border: "none",
              mb: 2,
            }}
          />
          <Typography
            variant="body2"
            sx={{
              opacity: 0.7,
              fontStyle: "italic",
              fontSize: { xs: "0.85rem", md: "0.95rem" },
            }}
          >
            {
              '"Crescimento \u2022 Rompimento \u2022 Velocidade \u2022 Frutificac\u0327a\u0303o"'
            }
          </Typography>
        </Container>
      </Box>

      {/* QUEM SOMOS + FUNDADORES */}
      <Container maxWidth="lg" sx={{ py: { xs: 5, md: 8 } }}>
        <Grid container spacing={5}>
          <Grid size={{ xs: 12, md: 6 }}>
            <Box
              sx={{
                p: { xs: 3, md: 4 },
                backgroundColor: "white",
                borderRadius: 4,
                boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
                height: "100%",
              }}
            >
              <Typography
                variant="overline"
                sx={{
                  color: "primary.main",
                  fontWeight: 700,
                  letterSpacing: 2,
                  fontSize: "0.7rem",
                }}
              >
                QUEM SOMOS
              </Typography>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 700,
                  mt: 1,
                  mb: 2.5,
                  color: "#1a1a2e",
                  lineHeight: 1.3,
                }}
              >
                Uma fam{"i\u0301"}lia comprometida com a Palavra da F{"e\u0301"}
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "#666", lineHeight: 1.9, mb: 1.5 }}
              >
                O Minist{"e\u0301"}rio Verbo da Vida coordena diversas instituic
                {"c\u0327o\u0303"}es evang{"e\u0301"}licas e est{"a\u0301"}{" "}
                ligado ao {'"'}Kenneth Hagin Ministries{'"'}, em Tulsa-OK,
                Estados Unidos.
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "#666", lineHeight: 1.9, mb: 1.5 }}
              >
                O Centro de Operac{"c\u0327o\u0303"}es est{"a\u0301"} sediado em
                Campina Grande (PB), na Rua Izabel Silveira Guimar{"a\u0303"}es,
                172 {"\u2013"} Sandra Cavalcante.
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "#666", lineHeight: 1.9 }}
              >
                A Igreja Verbo da Vida {"\u2014"} Zona Sul faz parte desse
                minist{"e\u0301"}rio e existe para levar a Palavra da F
                {"e\u0301"}, transformar vidas e libertar o povo brasileiro.
              </Typography>
            </Box>
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <Box
              sx={{
                p: { xs: 3, md: 4 },
                backgroundColor: "white",
                borderRadius: 4,
                boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography
                variant="overline"
                sx={{
                  color: "primary.main",
                  fontWeight: 700,
                  letterSpacing: 2,
                  fontSize: "0.7rem",
                }}
              >
                FUNDADORES
              </Typography>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 700,
                  mt: 1,
                  mb: 2.5,
                  color: "#1a1a2e",
                  lineHeight: 1.3,
                }}
              >
                Harold & Jan Wright
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "#666", lineHeight: 1.9, mb: 3, flex: 1 }}
              >
                Harold Leroy Wright {"\u2014"} conhecido como{" "}
                <strong>
                  {'"'}Bud{'"'}
                </strong>{" "}
                {"\u2014"} e Janace Sue Wright de Medeiros {"\u2014"}{" "}
                <strong>
                  {'"'}Jan{'"'}
                </strong>{" "}
                {"\u2014"} fundadores do Minist{"e\u0301"}rio Verbo da Vida, s
                {"a\u0303"}o norte-americanos e foram enviados pelo Senhor para
                trazer a Palavra da F{"e\u0301"} e libertar o povo brasileiro.
              </Typography>
              <Box
                sx={{
                  p: 2.5,
                  background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
                  borderRadius: 3,
                  color: "white",
                  textAlign: "center",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{ fontStyle: "italic", fontWeight: 600, lineHeight: 1.6 }}
                >
                  {'"Levar a Palavra da Fe\u0301 para libertar o Meu povo."'}
                </Typography>
                <Typography
                  variant="caption"
                  sx={{ opacity: 0.7, mt: 0.5, display: "block" }}
                >
                  {"Miss\u00e3o do Minist\u00e9rio Verbo da Vida"}
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>

      {/* MISSAO, VISAO, VALORES */}
      <Box
        sx={{
          background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
          py: { xs: 5, md: 8 },
          color: "white",
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={5}>
            {/* Missao + Visao */}
            <Grid size={{ xs: 12, md: 4 }}>
              <Typography
                variant="overline"
                sx={{
                  fontWeight: 700,
                  letterSpacing: 2,
                  opacity: 0.7,
                  fontSize: "0.7rem",
                }}
              >
                NOSSOS PILARES
              </Typography>
              <Typography variant="h5" sx={{ fontWeight: 700, mt: 1, mb: 4 }}>
                O que nos move
              </Typography>

              <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
                <Box
                  sx={{
                    p: 2.5,
                    backgroundColor: "rgba(255,255,255,0.1)",
                    borderRadius: 3,
                    backdropFilter: "blur(10px)",
                  }}
                >
                  <Typography
                    variant="overline"
                    sx={{ fontWeight: 700, opacity: 0.7, fontSize: "0.65rem" }}
                  >
                    {"MISS\u00c3O"}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontStyle: "italic",
                      lineHeight: 1.8,
                      mt: 0.5,
                      opacity: 0.95,
                    }}
                  >
                    {'"Levar a Palavra da Fe\u0301 para libertar o Meu povo."'}
                  </Typography>
                </Box>

                <Box
                  sx={{
                    p: 2.5,
                    backgroundColor: "rgba(255,255,255,0.1)",
                    borderRadius: 3,
                    backdropFilter: "blur(10px)",
                  }}
                >
                  <Typography
                    variant="overline"
                    sx={{ fontWeight: 700, opacity: 0.7, fontSize: "0.65rem" }}
                  >
                    {"VIS\u00c3O"}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ lineHeight: 1.8, mt: 0.5, opacity: 0.95 }}
                  >
                    {
                      "Alcanc\u0327ar o Brasil e as nac\u0327o\u0303es com a Palavra da Fe\u0301 e o amor."
                    }
                  </Typography>
                </Box>
              </Box>
            </Grid>

            {/* Valores */}
            <Grid size={{ xs: 12, md: 8 }}>
              <Typography
                variant="overline"
                sx={{
                  fontWeight: 700,
                  letterSpacing: 2,
                  opacity: 0.7,
                  fontSize: "0.7rem",
                }}
              >
                VALORES
              </Typography>
              <Typography variant="h5" sx={{ fontWeight: 700, mt: 1, mb: 4 }}>
                O que acreditamos
              </Typography>
              <Grid container spacing={1.5}>
                {valores.map((v, i) => (
                  <Grid size={{ xs: 6, sm: 4 }} key={i}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        p: 1.5,
                        backgroundColor: "rgba(255,255,255,0.1)",
                        borderRadius: 2,
                        backdropFilter: "blur(10px)",
                        transition: "all 0.2s",
                        "&:hover": {
                          backgroundColor: "rgba(255,255,255,0.18)",
                        },
                      }}
                    >
                      <Box
                        sx={{
                          width: 6,
                          height: 6,
                          borderRadius: "50%",
                          backgroundColor: "rgba(255,255,255,0.6)",
                          flexShrink: 0,
                        }}
                      />
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 500, opacity: 0.95 }}
                      >
                        {v}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* PASTOR + MAPA */}
      <Container maxWidth="lg" sx={{ py: { xs: 5, md: 8 } }}>
        <Grid container spacing={3} alignItems="stretch">
          {/* Pastor */}
          <Grid size={5}>
            <Box
              sx={{
                backgroundColor: "white",
                borderRadius: 4,
                boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
                overflow: "hidden",
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box
                sx={{
                  background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
                  py: 5,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Box
                  sx={{
                    width: 80,
                    height: 80,
                    borderRadius: "50%",
                    backgroundColor: "rgba(255,255,255,0.15)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "2px solid rgba(255,255,255,0.3)",
                  }}
                >
                  <Church sx={{ fontSize: 40, color: "white" }} />
                </Box>
              </Box>
              <Box
                sx={{
                  p: 3,
                  textAlign: "center",
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <Typography
                  variant="overline"
                  sx={{
                    color: "primary.main",
                    fontWeight: 700,
                    letterSpacing: 2,
                    fontSize: "0.65rem",
                  }}
                >
                  {"LIDERANC\u0327A"}
                </Typography>
                <Typography
                  variant="h5"
                  sx={{ fontWeight: 700, color: "#1a1a2e", mt: 0.5 }}
                >
                  {"Pr. Fa\u0301bio Amorim"}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "primary.main", fontWeight: 600, mb: 2 }}
                >
                  Pastor Titular
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "#666", lineHeight: 1.8 }}
                >
                  {
                    "Dedicado ao minist\u00e9rio de pregar a Palavra de Deus com clareza e poder, conduzindo nossa comunidade no crescimento espiritual e no cumprimento da Grande Comiss\u00e3o."
                  }
                </Typography>
              </Box>
            </Box>
          </Grid>

          {/* Mapa */}
          <Grid size={7}>
            <Box
              sx={{
                backgroundColor: "white",
                borderRadius: 4,
                boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
                overflow: "hidden",
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box sx={{ p: 3, pb: 0 }}>
                <Typography
                  variant="overline"
                  sx={{
                    color: "primary.main",
                    fontWeight: 700,
                    letterSpacing: 2,
                    fontSize: "0.65rem",
                  }}
                >
                  {"LOCALIZAC\u0327\u00c3O"}
                </Typography>
                <Typography
                  variant="h5"
                  sx={{ fontWeight: 700, color: "#1a1a2e", mt: 0.5, mb: 2 }}
                >
                  Como nos encontrar
                </Typography>
              </Box>
              <Box sx={{ flex: 1, minHeight: 350 }}>
                <iframe
                  title={"Localiza\u00e7\u00e3o da Igreja"}
                  src="https://www.google.com/maps?q=Rua+Isaque+Cat%C3%A3o,+Jardim+Paulistano,+Campina+Grande,+PB&output=embed"
                  width="100%"
                  height="100%"
                  style={{ border: 0, display: "block", minHeight: 350 }}
                  allowFullScreen=""
                  loading="lazy"
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};
